import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleModal } from '../store/actions/toggleModalActions';
import {
    addUser,
    editUser,
    deleteUser,
    getUserModules,
    getUATFilters,
    activateUserModule, deactivateUserModule
} from '../store/actions/usersActions';
import {getCompanyId, getLoggedUserId, isDistributorAdmin, isSuperAdmin, isValidPhoneNumber} from "../helpers/helpers";
import { isValidNip } from '../helpers/helpers';
import './UserModal.scss';

import { ReactComponent as AddUserIcon } from '../assets/icons/add_user.svg';
import ButtonSpinner from './_common/ButtonSpinner';
import Switch from 'react-switch';
import Select from "react-select";
import {customStyles} from "../helpers/selectStyles";

const selector = state => {
    const { language, disableButtons, users, companies, modalState } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: users.selected,
        companies: companies.companies,
        modalState: modalState,
        userModules: users.userModules
    }
};

const UserModal = props => {
  const {edit, user, handleClearDeviceIdsClick, handleResetPasswordClick, details, superAdmin, responsive} = props;
  const {t, disableButtons, selected, companies,userModules} = useSelector(selector);
  const dispatch = useDispatch();
  const userCompany = user ? companies.find(x => x.id === Number(user.companyId)) : '';
  const companiesOptions = companies && companies.length > 0 ? companies.map(x => ({...x, value: x.id, label: x.name})) : []

    const [firstName, setFirstName] = useState(user ? user.firstName : '');
    const [lastName, setLastName] = useState(user ? user.lastName : '');
    const [email, setEmail] = useState(user ? user.email : '');
    const [password, setPassword] = useState(user ? user.password : '');
    const [phoneNr, setPhoneNr] = useState(user ? user.password : '');
    const [invalidPhoneNr, setInvalidPhoneNr] = useState(false);
    const [nip, setNIP] = useState(user ? user.nip : '');
    const [invalidNip, setInvalidNip] = useState(false);
    const [needInvoice, setNeedInvoice] = useState(user ? user.needInvoice : false);
    const [allowedDeviceNumber, setAllowedDeviceNumber] = useState(user ? user.allowedDeviceNumber : '');
    const [isCommunityDataPresented, setIsCommunityDataPresented] = useState(user
        ? !!user.isCommunityDataPresented
        : false
    );
    const [company, setCompany] = useState(user ? {id: userCompany.id, name: userCompany.name} : '');
    const [showCompanyOptions, setShowCompanyOptions] = useState(false);
    const [role, setRole] = useState(user ? user.role : isSuperAdmin() ? 'COMPANY_ADMIN' : 'CUSTOMER');
    const [showRoleOptions, setShowRoleOptions] = useState(false);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const [selectedCompany, setSelectedCompany] = useState(null)

    const [isGreencloudModuleOn, setIsGreencloudModuleOn] = useState(false);
    const [confirmTogglePending, setConfirmTogglePending] = useState(false);
    const [pendingToggleValue, setPendingToggleValue] = useState(null);


    useEffect(() => {
       if(edit) {
           if(user) {
               const uCompany = companiesOptions.find(x => x.id === Number(user.companyId));
               setSelectedCompany(uCompany)
           }
       }
    },[])

    useEffect(() => {
        if(edit) {
           if(user && superAdmin) {
               dispatch(getUserModules(user.id))
           }
       }
    },[])
    //
    // useEffect(() => {
    //    if(edit) {
    //        if(user && superAdmin) {
    //            dispatch(getUserModules(user.id))
    //        }
    //    }
    // },[])


    const roles = () => {
        let roles;
        if(isSuperAdmin()) {
            roles =  [
                'COMPANY_ADMIN',
                'SUPER_ADMIN',
                'DISTRIBUTOR_ADMIN'
            ]
        } else if(isDistributorAdmin()) {
            roles = [
                'CUSTOMER',
                'DEMO_USER'
            ]
        } else {
            roles = [
                'CUSTOMER',
                'COMPANY_USER',
                'DEMO_USER'
            ];
        }
           return roles
    }

  const closeModal = () => {
    dispatch(toggleModal(false, ''));
  };

  const handleAddUserClick = () => {
    if (isFormValid()) {
      const userData = {
        firstName,
        lastName,
        fullName: firstName + ' ' + lastName,
        email,
        allowedDeviceNumber,
        password,
        phoneNr,
        role,
        companyId: isSuperAdmin() ? company.id : getCompanyId(),
        nip,
        needInvoice,
        isCommunityDataPresented
      };

      dispatch(addUser(superAdmin,userData));

      closeModal();
    }
  };

  const handleEditUserClick = () => {
    if (isFormValid()) {
      const userData = {
        id: user.id,
        firstName,
        lastName,
        fullName: firstName + ' ' + lastName,
        email,
        allowedDeviceNumber,
        phoneNr,
        iconUrl: user.iconUrl,
        role,
        companyId: isSuperAdmin() ? company.id : getCompanyId(),
        nip,
        needInvoice,
        isCommunityDataPresented
      };

      dispatch(editUser(superAdmin,userData, selected.page));

      closeModal();
    }
  };

  const handleDeleteUserClick = () => {
    setDeleteConfirmation(!deleteConfirmation)
  };

  const confirmDeleteUserClick = id => {
    dispatch(deleteUser(superAdmin, id, selected.page));
    closeModal();
  };

  const isFormValid = () => {
    setInvalidNip(!isValidNip(nip));
    setInvalidPhoneNr(!isValidPhoneNumber(phoneNr, role !== 'DEMO_USER'));
    return isValidNip(nip) && isValidPhoneNumber(phoneNr, role !== 'DEMO_USER');
  };

  const selectCompany = (company) => {
      if(company) {
          setCompany({name: company.name, id: company.id})
      }
     setSelectedCompany(company)
  }

  if(responsive) {
      return (
          <div style={{padding: '0', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 'calc(100% - 20px)'}}  className='userModalContent'>
              <form className='userForm' autoComplete='off'>
                  {isSuperAdmin() &&
                      <div className='userFormItem'>
                          <label className='userFormLabel'>
                              {t.gettext('Company')}
                          </label>
                          <div style={{height: '45px', marginTop: '10px'}} className="selectContainer">
                              <Select
                                  options={companiesOptions}
                                  maxMenuHeight={200}
                                  placeholder={t.gettext('Select...')}
                                  styles={customStyles}
                                  isSearchable
                                  onChange={(company) => selectCompany(company)}
                                  value={selectedCompany}
                                  // onChange={selectWarmTemperatureConfig}
                                  // value={selectedTemperatureConfig}
                                  noOptionsMessage={() => t.gettext('No options')}
                              />
                          </div>
                          {/*<div*/}
                          {/*    className='userFormSelect'*/}
                          {/*    onClick={() => setShowCompanyOptions(!showCompanyOptions)}*/}
                          {/*>*/}
                          {/*    <div className='userFormSelectText'>*/}
                          {/*        {company.name}*/}
                          {/*    </div>*/}
                          {/*    <i className="material-icons dropDownIcon">*/}
                          {/*        {showCompanyOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}*/}
                          {/*    </i>*/}
                          {/*    {showCompanyOptions &&*/}
                          {/*        <div className='userFormSelectOptions'>*/}
                          {/*            {companies.map((item, index) => (*/}
                          {/*                <div*/}
                          {/*                    className='userFormSelectOption'*/}
                          {/*                    key={index}*/}
                          {/*                    onClick={() => setCompany({name: item.name, id: item.id})}*/}
                          {/*                >*/}
                          {/*                    {item.name}*/}
                          {/*                </div>*/}
                          {/*            ))}*/}
                          {/*        </div>*/}
                          {/*    }*/}
                          {/*</div>*/}
                      </div>
                  }
                  <div className='userFormItem'>
                      <label className='userFormLabel'>
                          {t.gettext('Role')}
                      </label>
                      <div
                          className='userFormSelect'
                          onClick={() => setShowRoleOptions(!showRoleOptions)}
                      >
                          <div className='userFormSelectText'>
                              {role}
                          </div>
                          <i className="material-icons dropDownIcon">
                              {showRoleOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                          </i>
                          {showRoleOptions &&
                              <div className='userFormSelectOptions'>
                                  {roles().map((item, index) => (
                                      <div
                                          className='userFormSelectOption'
                                          key={index}
                                          onClick={() => setRole(item)}
                                      >
                                          {item}
                                      </div>
                                  ))}
                              </div>
                          }
                      </div>
                  </div>
                  <div className='userFormItem'>
                      <label className='userFormLabel'>
                          {t.gettext('First Name')}
                      </label>
                      <input
                          className='userFormInput'
                          defaultValue={user ? user.firstName : ''}
                          onInput={e => {
                              setFirstName(e.target.value);
                          }}
                          type='text'
                      />
                  </div>
                  <div className='userFormItem'>
                      <label className='userFormLabel'>
                          {t.gettext('Last Name')}
                      </label>
                      <input
                          className='userFormInput'
                          defaultValue={user ? user.lastName : ''}
                          onInput={e => {
                              setLastName(e.target.value);
                          }}
                          type='text'
                      />
                  </div>
                  <div className='userFormItem'>
                      <label className='userFormLabel'>
                          {t.gettext('Email')}
                      </label>
                      <input
                          className='userFormInput'
                          defaultValue={user ? user.email : ''}
                          onInput={e => {
                              setEmail(e.target.value);
                          }}
                          type='email'
                          disabled={!!user}
                      />
                  </div>
                  {!user &&
                      <div className='userFormItem'>
                          <label className='userFormLabel'>
                              {t.gettext('Password')}
                          </label>
                          <input
                              className='userFormInput'
                              onInput={e => {
                                  setPassword(e.target.value);
                              }}
                              type='password'
                          />
                      </div>
                  }
                  {!isDistributorAdmin() &&
                      <div className='userFormItem'>
                          <label className='userFormLabel'>
                              {t.gettext('Allowed device number')}
                          </label>
                          <input
                              className='userFormInput'
                              defaultValue={user ? user.allowedDeviceNumber : ''}
                              onInput={e => {
                                  setAllowedDeviceNumber(e.target.value);
                              }}
                              type='text'
                          />
                      </div>
                  }
                  <div className='userFormItem'>
                      <label className='userFormLabel'>
                          {t.gettext('Phone number')}
                      </label>
                      {invalidPhoneNr &&
                          <div className='userFormErrorMessage'>{t.gettext('Phone number is invalid')}</div>
                      }
                      <input
                          className='userFormInput'
                          defaultValue={user ? user.phoneNr : ''}
                          onInput={e => {
                              setInvalidPhoneNr(false);
                              setPhoneNr(e.target.value);
                          }}
                          type='text'
                      />
                  </div>
                  <div className='userFormItem'>
                      <label className='userFormLabel'>
                          {t.gettext('nip')}
                      </label>
                      {invalidNip &&
                          <div className='userFormErrorMessage'>{t.gettext('NIP number is invalid')}</div>
                      }
                      <input
                          className='userFormInput'
                          defaultValue={user ? user.nip : ''}
                          onInput={e => {
                              setInvalidNip(false);
                              setNIP(e.target.value);
                          }}
                          type='text'
                      />
                  </div>
                  <div className="userFormContainer">
                      <div className='userFormItem'>
                          <label className='userFormLabel userFormLabel--withMargin'>
                              {t.gettext('Need invoice')}
                          </label>
                          <Switch onChange={(needInvoice) => setNeedInvoice(needInvoice)} checked={needInvoice}/>
                      </div>
                      <div className='userFormItem'>
                          <label className='userFormLabel userFormLabel--withMargin'>
                              {t.gettext('Community Data')}
                          </label>
                          <Switch
                              onChange={(isCommunityDataPresented) => setIsCommunityDataPresented(isCommunityDataPresented)}
                              checked={isCommunityDataPresented}
                          />
                      </div>
                      {superAdmin && edit && userModules?.find(x => x.moduleType === 'GREENCLOUD_VIEW') && (
                          <div className='userFormItem'>
                              <label className='userFormLabel userFormLabel--withMargin'>
                                  {t.gettext('Greencloud Module')}
                              </label>
                              <Switch
                                  checked={userModules?.find(x => x.moduleType === 'GREENCLOUD_VIEW')?.moduleActivated}
                                  onChange={(checked) => {
                                      setPendingToggleValue(checked);          // Store user's intention
                                      setConfirmTogglePending(true);           // Show confirmation prompt
                                  }}
                              />
                          </div>
                      )}
                  </div>

                  {confirmTogglePending && (
                      <div className="toggleConfirmOverlay">
                          <div className="toggleConfirmModal">
                              {t.gettext('Are you sure you want to ') + (pendingToggleValue ? t.gettext('activate') : t.gettext('deactivate')) + ' Greencloud Module?'}
                              <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
                                  <button
                                      className="toggleConfirmButton"
                                      onClick={async (e) => {
                                          e.preventDefault();

                                          if (pendingToggleValue) {
                                              await dispatch(activateUserModule(user.id, 'GREENCLOUD_VIEW'));
                                          } else {
                                              await dispatch(deactivateUserModule(user.id, 'GREENCLOUD_VIEW'));
                                          }

                                          setIsGreencloudModuleOn(pendingToggleValue);
                                          await new Promise(resolve => setTimeout(resolve, 500));
                                          await dispatch(getUserModules(user.id));

                                          setConfirmTogglePending(false);
                                          setPendingToggleValue(null);
                                      }}
                                  >
                                      {t.gettext('OK')}
                                  </button>
                                  <button
                                      className="toggleConfirmButton toggleConfirmButton--cancel"
                                      onClick={(e) => {
                                          e.preventDefault();
                                          setConfirmTogglePending(false);
                                          setPendingToggleValue(null);
                                      }}
                                  >
                                      {t.gettext('Cancel')}
                                  </button>
                              </div>
                          </div>
                      </div>
                  )}
                  <div className='userButtonsHolder'>
                      {!edit &&
                          <button
                              className='userAddButton'
                              onClick={e => {
                                  e.preventDefault();
                                  handleAddUserClick();
                              }}
                              disabled={disableButtons}
                          >
                              {t.gettext('Add User')}
                              {disableButtons && <ButtonSpinner black/>}
                          </button>
                      }

                      {edit &&
                          <button
                              className='userAddButton userEditButton'
                              onClick={e => {
                                  e.preventDefault();
                                  handleEditUserClick();
                              }}
                              disabled={disableButtons}
                          >
                              {t.gettext('Save')}
                              {disableButtons && <ButtonSpinner black/>}
                          </button>
                      }

                      {edit &&
                          <button
                              className='userAddButton userDeleteButton'
                              onClick={e => {
                                  e.preventDefault();
                                  handleDeleteUserClick();
                              }}
                              disabled={disableButtons}
                          >
                              {t.gettext('Delete User')}
                          </button>
                      }
                  </div>
                  {deleteConfirmation &&
                      <div className='userDeleteConfirmation'>
                          {user.firstName + ' ' + user.lastName + ' ' + t.gettext('will be deleted')}
                          <button
                              className='confirmationButton'
                              onClick={e => {
                                  e.preventDefault();
                                  confirmDeleteUserClick(user.id);
                              }}
                              disabled={disableButtons}
                          >
                              {t.gettext('OK')}
                          </button>
                          <button
                              className='confirmationButton confirmationButton--cancel'
                              onClick={e => {
                                  e.preventDefault();
                                  handleDeleteUserClick();
                              }}
                              disabled={disableButtons}
                          >
                              {t.gettext('Cancel')}
                          </button>
                      </div>
                  }
                  <div className='userButtonsHolder'>
                      {edit &&
                          <button
                              className='userAddButton userEditButton'
                              onClick={e => {
                                  e.preventDefault();
                                  handleClearDeviceIdsClick();
                              }}
                              disabled={disableButtons}
                          >
                              {t.gettext('Clear device Ids')}
                              {disableButtons && <ButtonSpinner black/>}
                          </button>
                      }
                      {edit &&
                          <button
                              className='userAddButton userEditButton'
                              onClick={e => {
                                  e.preventDefault();
                                  handleResetPasswordClick();
                              }}
                              disabled={disableButtons}
                          >
                              {t.gettext('Reset password')}
                              {disableButtons && <ButtonSpinner black/>}
                          </button>
                      }
                  </div>
              </form>
          </div>
      )
  }

    return (
        <div
            className={details ? 'userModalDetails' : 'userModalBlur'}
            // onClick={e => {
            //     if (e.target.className === 'userModalBlur') {
            //         closeModal()
            //     }
            // }}
        >
            <div className={details ? 'userModal inDetails' : 'userModal'}>
                <div className="userModalHeader">
                    <div className="userModalTitleContainer">
                        {!edit &&
                            <AddUserIcon className='userModalTitleIcon'/>
                        }
                        <div className='userModalTitle'>
                            {!edit ? t.gettext('Add New User') : t.gettext('Edit / Delete User')}
                        </div>
                    </div>
                    <div className='userModalCloseButtonHolder'>
                        <span
                            className='material-icons userModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div className='userModalContent'>
                    <form className='userForm' autoComplete='off'>
                        {isSuperAdmin() &&
                            <div className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Company')}
                                </label>
                                <div style={{height: '45px', marginTop: '10px'}} className="selectContainer">
                                    <Select
                                        options={companiesOptions}
                                        maxMenuHeight={200}
                                        placeholder={t.gettext('Select...')}
                                        styles={customStyles}
                                        isSearchable
                                        onChange={(company) => selectCompany(company)}
                                        value={selectedCompany}
                                        // onChange={selectWarmTemperatureConfig}
                                        // value={selectedTemperatureConfig}
                                        noOptionsMessage={() => t.gettext('No options')}
                                    />
                                </div>

                                {/*<div*/}
                                {/*    className='userFormSelect'*/}
                                {/*    onClick={() => setShowCompanyOptions(!showCompanyOptions)}*/}
                                {/*>*/}
                                {/*    <div className='userFormSelectText'>*/}
                                {/*        {company.name}*/}
                                {/*    </div>*/}
                                {/*    <i className="material-icons dropDownIcon">*/}
                                {/*        {showCompanyOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}*/}
                                {/*    </i>*/}
                                {/*    {showCompanyOptions &&*/}
                                {/*        <div className='userFormSelectOptions'>*/}
                                {/*            {companies.map((item, index) => (*/}
                                {/*                <div*/}
                                {/*                    className='userFormSelectOption'*/}
                                {/*                    key={index}*/}
                                {/*                    onClick={() => setCompany({name: item.name, id: item.id})}*/}
                                {/*                >*/}
                                {/*                    {item.name}*/}
                                {/*                </div>*/}
                                {/*            ))}*/}
                                {/*        </div>*/}
                                {/*    }*/}
                                {/*</div>*/}
                            </div>
                        }
                        <div style={{display: 'flex', justifyContent: 'space-between'}} className="doubleUserFormItem">
                            <div style={{width: '49%'}} className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Role')}
                                </label>
                                <div
                                    className='userFormSelect'
                                    onClick={() => setShowRoleOptions(!showRoleOptions)}
                                >
                                    <div className='userFormSelectText'>
                                        {role}
                                    </div>
                                    <i className="material-icons dropDownIcon">
                                        {showRoleOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                                    </i>
                                    {showRoleOptions &&
                                        <div className='userFormSelectOptions'>
                                            {roles().map((item, index) => (
                                                <div
                                                    className='userFormSelectOption'
                                                    key={index}
                                                    onClick={() => setRole(item)}
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div style={{width: '49%'}} className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('User ID')}
                                </label>
                                <input
                                    className='userFormInput'
                                    defaultValue={user ? user.id : ''}
                                    type='text'
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('First Name')}
                            </label>
                            <input
                                className='userFormInput'
                                defaultValue={user ? user.firstName : ''}
                                onInput={e => {
                                    setFirstName(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('Last Name')}
                            </label>
                            <input
                                className='userFormInput'
                                defaultValue={user ? user.lastName : ''}
                                onInput={e => {
                                    setLastName(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('Email')}
                            </label>
                            <input
                                className='userFormInput'
                                defaultValue={user ? user.email : ''}
                                onInput={e => {
                                    setEmail(e.target.value);
                                }}
                                type='email'
                                disabled={!!user}
                            />
                        </div>
                        {!user &&
                            <div className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Password')}
                                </label>
                                <input
                                    className='userFormInput'
                                    onInput={e => {
                                        setPassword(e.target.value);
                                    }}
                                    type='password'
                                />
                            </div>
                        }
                        {!isDistributorAdmin() &&
                            <div className='userFormItem'>
                                <label className='userFormLabel'>
                                    {t.gettext('Allowed device number')}
                                </label>
                                <input
                                    className='userFormInput'
                                    defaultValue={user ? user.allowedDeviceNumber : ''}
                                    onInput={e => {
                                        setAllowedDeviceNumber(e.target.value);
                                    }}
                                    type='text'
                                />
                            </div>
                        }
                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('Phone number')}
                            </label>
                            {invalidPhoneNr &&
                                <div className='userFormErrorMessage'>{t.gettext('Phone number is invalid')}</div>
                            }
                            <input
                                className='userFormInput'
                                defaultValue={user ? user.phoneNr : ''}
                                onInput={e => {
                                    setInvalidPhoneNr(false);
                                    setPhoneNr(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='userFormItem'>
                            <label className='userFormLabel'>
                                {t.gettext('nip')}
                            </label>
                            {invalidNip &&
                                <div className='userFormErrorMessage'>{t.gettext('NIP number is invalid')}</div>
                            }
                            <input
                                className='userFormInput'
                                defaultValue={user ? user.nip : ''}
                                onInput={e => {
                                    setInvalidNip(false);
                                    setNIP(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className="userFormContainer">
                            <div className='userFormItem'>
                                <label className='userFormLabel userFormLabel--withMargin'>
                                    {t.gettext('Need invoice')}
                                </label>
                                <Switch onChange={(needInvoice) => setNeedInvoice(needInvoice)} checked={needInvoice}/>
                            </div>
                            <div className='userFormItem'>
                                <label className='userFormLabel userFormLabel--withMargin'>
                                    {t.gettext('Community Data')}
                                </label>
                                <Switch
                                    onChange={(isCommunityDataPresented) => setIsCommunityDataPresented(isCommunityDataPresented)}
                                    checked={isCommunityDataPresented}
                                />
                            </div>
                            {superAdmin && edit && userModules?.find(x => x.moduleType === 'GREENCLOUD_VIEW') && (
                                <div className='userFormItem'>
                                    <label className='userFormLabel userFormLabel--withMargin'>
                                        {t.gettext('Greencloud Module')}
                                    </label>
                                    <Switch
                                        checked={userModules?.find(x => x.moduleType === 'GREENCLOUD_VIEW')?.moduleActivated}
                                        onChange={(checked) => {
                                            setPendingToggleValue(checked);          // Store user's intention
                                            setConfirmTogglePending(true);           // Show confirmation prompt
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        {confirmTogglePending && (
                            <div className="toggleConfirmOverlay">
                                <div className="toggleConfirmModal">
                                    {t.gettext('Are you sure you want to ') + (pendingToggleValue ? t.gettext('activate') : t.gettext('deactivate')) + ' Greencloud Module?'}
                                    <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
                                        <button
                                            className="toggleConfirmButton"
                                            onClick={async (e) => {
                                                e.preventDefault();

                                                if (pendingToggleValue) {
                                                    await dispatch(activateUserModule(user.id, 'GREENCLOUD_VIEW'));
                                                } else {
                                                    await dispatch(deactivateUserModule(user.id, 'GREENCLOUD_VIEW'));
                                                }

                                                setIsGreencloudModuleOn(pendingToggleValue);
                                                await new Promise(resolve => setTimeout(resolve, 500));
                                                await dispatch(getUserModules(user.id));

                                                setConfirmTogglePending(false);
                                                setPendingToggleValue(null);
                                            }}
                                        >
                                            {t.gettext('OK')}
                                        </button>
                                        <button
                                            className="toggleConfirmButton toggleConfirmButton--cancel"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setConfirmTogglePending(false);
                                                setPendingToggleValue(null);
                                            }}
                                        >
                                            {t.gettext('Cancel')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className='userButtonsHolder'>
                            {!edit &&
                                <button
                                    className='userAddButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleAddUserClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Add User')}
                                    {disableButtons && <ButtonSpinner black/>}
                                </button>
                            }

                            {edit &&
                                <button
                                    className='userAddButton userEditButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleEditUserClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Save')}
                                    {disableButtons && <ButtonSpinner black/>}
                                </button>
                            }

                            {edit &&
                                <button
                                    className='userAddButton userDeleteButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleDeleteUserClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Delete User')}
                                </button>
                            }
                        </div>

                        {deleteConfirmation &&
                            <div className='userDeleteConfirmation'>
                                {user.firstName + ' ' + user.lastName + ' ' + t.gettext('will be deleted')}
                                <button
                                    className='confirmationButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        confirmDeleteUserClick(user.id);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('OK')}
                                </button>
                                <button
                                    className='confirmationButton confirmationButton--cancel'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleDeleteUserClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Cancel')}
                                </button>
                            </div>
                        }
                        <div className='userButtonsHolder'>
              {edit &&
                <button
                  className='userAddButton userEditButton'
                  onClick={e => {
                    e.preventDefault();
                    handleClearDeviceIdsClick();
                  }}
                  disabled={disableButtons}
                >
                  {t.gettext('Clear device Ids')}
                  {disableButtons && <ButtonSpinner black/>}
                </button>
              }
              {edit &&
                <button
                  className='userAddButton userEditButton'
                  onClick={e => {
                    e.preventDefault();
                    handleResetPasswordClick();
                  }}
                  disabled={disableButtons}
                >
                  {t.gettext('Reset password')}
                  {disableButtons && <ButtonSpinner black/>}
                </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
